import React, { useState, useEffect, useMemo, useCallback } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import Input from "../../../../../components/Common/Input/Input";
import Button from "../../../../../components/Common/Button/Button";
import Tooltip from "../../../../../components/Common/ToolTip/Tooltip";
import InfoIcon from "../../../../../components/Common/SvgIcons/SocialIcons/InfoIcon";
import {
  useLocation,
  useNavigate,
  useOutletContext,
  useParams,
} from "react-router";
import { topicManagement } from "../../../../../utils/mainTabs/organize/topicManagement";
import { setErrorHandler } from "../../../../../store/actions/actionHandlers/errorActionHandler";
import { errorTypes } from "../../../../../utils/errorTypes";
import { addNewTopic } from "../../../../../utils/mainTabs/organize/addNewTopic";
import {
  getSearchTopicTagsActionHandler,
  isTopicExistsActionHandler,
} from "../../../../../store/actions/actionHandlers/organizeActionHandler";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import classes from "./NewTopicDetail.module.scss";
import {
  setProgramDataAction,
  setShotClassDataAction,
} from "../../../../../store/actions/actionCreators/organizeActionCreator";
import { FormattedMessage, injectIntl } from "react-intl";
import Loader from "../../../../../components/Common/Loader/Loader";

export const groupTopicSchema = yup.object().shape({
  name: yup.string().required("Name is required!"),
  // TagsList: yup
  //   .array(
  //     yup.object().shape({
  //       TagName: yup.string(),
  //       TagValue: yup.string(),
  //     })
  //   )
  //   .min(1, "Tag is required!"),
  description: yup.string().required("Description is required!"),
  thumbnailImageFile: yup
    .mixed()
    .test("thumbnailImageFile", "Thumbnail Image is required!", (value) => {
      if (value?.length < 1) return false;
      return true;
    }),
  // thumbnailImageFile: yup
  //   .mixed()
  //   .transform((v) => (!v ? undefined : v))
  //   .required("Thumbnail Image is required!"),
});

const NewTopicDetail = ({ intl }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const routerParams = useParams();
  const [searchTagsList, setSearchTagsList] = useState([]);
  const [exitTopicExist, setExitTopicExist] = useState(null);
  const [removeViewButtonAfterCancel, setRemoveViewButtonAfterCancel] =
    useState(true);
  const [validClassName, setValidClassName] = useState(true);
  const [validTagSearch, setValidTagSearch] = useState(true);
  const [loader, setLoader] = useState(true);
  const [fileSize, setFileSize] = useState();
  const {
    formData,
    setFormData,
    pathType,
    shotClassData,
    programData,
    tenantName,
    topicEditPath,
  } = useOutletContext();
  const methods = useForm({
    mode: "onChange",
    resolver: yupResolver(groupTopicSchema),
    defaultValues: useMemo(() => {
      return {
        ...formData.details,
      };
    }),
  });

  // useEffect(() => {
  //   if(formData?.details?.thumbnailImageFile){

  //   }
  // }, [])

  const {
    handleSubmit,
    formState: { errors, isValid, isDirty },
    reset,
    watch,
    trigger,
    setValue,
  } = methods;
  let thumbinalViewBtn = watch("thumbnailImageFile");
  useEffect(() => {
    setLoader(true);
    reset(() => formData?.details);
  }, [formData?.details]);
  useEffect(() => {
    if (formData?.details?.name) {
      setLoader(false);
    }
  }, [setLoader, formData?.details?.name]);
  const clearAll = () => {
    // if (formData?.details.TagsList) {
    //   reset();
    // } else {
    //   reset({
    //     name: formData?.details?.name ? formData?.details?.name : "",
    //     description: formData?.details?.description
    //       ? formData?.details?.description
    //       : "",
    //     thumbnailImageFile: formData?.details?.thumbnailImageFile
    //       ? formData?.details?.thumbnailImageFile
    //       : [],
    //   });
    // }
    reset({
      name: formData?.details?.name ? formData?.details?.name : "",
      description: formData?.details?.description ? formData?.details?.description : "",
      thumbnailImageFile: formData?.details?.thumbnailImageFile ? formData?.details?.thumbnailImageFile : [],
      TagsList: formData?.details?.TagsList ? formData?.details?.TagsList : [],
    });
  };
  console.log(formData?.details);
  const handleNameExists = useCallback(
    (e) => {
      let val = e.target.value.trim() !== "" && e.target.value;
      if (val) {
        if (/^[a-zA-Z0-9:_@?#|'`\]\[ ]*$/.test(val)) {
          setValidClassName(true);
          dispatch(isTopicExistsActionHandler(val, setExitTopicExist));
        } else {
          setValidClassName(false);
        }
      } else {
        setValidClassName(true);
        setExitTopicExist(false);
      }
    },
    [dispatch, setExitTopicExist, setValidClassName]
  );
  const handleSearchTags = useCallback(
    (e) => {
      let val = e.target.value.trim() !== "" && e.target.value;
      if (val) {
        if (/^[A-Za-z0-9@# ]+$/.test(val)) {
          setValidTagSearch(true);
          dispatch(
            getSearchTopicTagsActionHandler(e.target.value, setSearchTagsList)
          );
        } else {
          setValidTagSearch(false);
        }
      } else {
        setValidTagSearch(true);
        setSearchTagsList([]);
      }
    },
    [dispatch, setValidTagSearch]
  );
  const handleCancelImage = useCallback(() => {
    setRemoveViewButtonAfterCancel(false);
    trigger(["ThumbnailImage"]);
  }, [trigger, setRemoveViewButtonAfterCancel]);

  let maxSize = 1048576 * 10;
  const fileChange = (event) => {
    event.preventDefault();
    let files = event.target.files[0];
    const accept = ["image/png", "image/jpeg", "image/gif", "image/bmp"];
    if (!accept.includes(files.type)) {
      setValue("thumbnailImageFile", "");
      dispatch(
        setErrorHandler(
          errorTypes.WARN,
          "Please select a valid format from [.png, .jpg, .gif, .bmp]"
        )
      );
    } else if (files.size > maxSize) {
      setValue("thumbnailImageFile", "");
      dispatch(
        setErrorHandler(
          errorTypes.FAIL,
          "Max file size should not be greater than 10MB"
        )
      );
    }
  };
  const onSubmit = (data) => {
    setFormData((formData) => {
      return {
        ...formData,
        details: {
          ...formData?.details,
          ...data,
        },
      };
    });
    if (pathType === "edit") {
      navigate(
        `${addNewTopic.editpath(tenantName)}/${
          routerParams?.topicID
        }/topicContent`
      );
    } else {
      const initialProgramStateUpdate = programData?.map((item) => {
        if (item?.isChecked) {
          return { ...item, isChecked: false, disabled: false };
        } else {
          return item;
        }
      });
      dispatch(setProgramDataAction(initialProgramStateUpdate));
      const initialShotclassStateUpdate = shotClassData?.map((item) => {
        if (item?.isChecked) {
          return { ...item, isChecked: false, disabled: false };
        } else {
          return item;
        }
      });
      dispatch(setShotClassDataAction(initialShotclassStateUpdate));
      navigate(
        `${addNewTopic.path(location, routerParams, tenantName)}/topicContent`
      );
    }
  };
  return loader && location.pathname.includes(topicEditPath) ? (
    <Loader page />
  ) : (
    <div className={classes.newTopicDetailsMain}>
      <FormProvider {...methods}>
        <h1 className={classes.title}>Subtopic Details</h1>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className={classes.topicFormsMain}>
            <div className={classes.topicForms}>
              <div className={classes.topicDetails}>
                <Input
                  label={<FormattedMessage id="USERGROUP_NAME" />}
                  name="name"
                  // placeholder={intl.formatMessage({
                  //   id: `TOPIC_NAME_PLACEHOLDER`,
                  // })}
                  placeholder={"Enter Subtopic Name"}
                  labelColor="dark"
                  required
                  onChange={handleNameExists}
                  maxLength={100}
                  // disabled={location.pathname.includes(topicEditPath)}
                  error={errors?.name?.message}
                />
                {errors?.Name?.message ? (
                  <div className={classes.topicAlreadyExist}>
                    {errors.name?.message}
                  </div>
                ) : exitTopicExist ? (
                  <div className={classes.topicAlreadyExist}>
                    Sorry, name already exists
                  </div>
                ) : !validClassName ? (
                  <div className={classes.topicAlreadyExist}>
                    Only alphanumeric and special characters like ':#@?[]_`| are
                    allowed
                  </div>
                ) : (
                  <></>
                )}
                {/* {exitTopicExist ? (
                  <div className={classes.topicAlreadyExist}>
                    Sorry, name already exists
                  </div>
                ) : (
                  <div className={classes.topicAlreadyExist}>
                    {errors.name?.message}
                  </div>
                )} */}
              </div>
              <div className={classes.userGroupDiv}>
                <Input
                  label={"Search Tag"}
                  name="TagsList"
                  fieldName="TagName"
                  fieldValue="TagValue"
                  placeholder={"Enter Multiple Tags Here"}
                  labelColor="dark"
                  // required
                  type="tags"
                  searchTagsList={searchTagsList}
                  isValidTagSearch={validTagSearch}
                  onChange={(e) => handleSearchTags(e)}
                  // error={errors?.searchTag?.message}
                />
                {!validTagSearch && (
                  <div className={classes.topicAlreadyExist}>
                    Only alphanumeric and special characters like @# are allowed
                  </div>
                )}
              </div>
              <Input
                label={<FormattedMessage id="DESCRIPTION_TEXT" />}
                name="description"
                placeholder={"Enter Subtopic Description..."}
                labelColor="dark"
                required
                maxLength={200}
                error={errors?.description?.message}
              />
            </div>
            <div className={classes.uploadThumbnailBtn}>
              <Input
                label={<FormattedMessage id="UPLOADIMAGE_TEXT" />}
                name="thumbnailImageFile"
                labelColor="dark"
                hidden
                type="file"
                required="true"
                accept=".png, .jpg, .gif, .bmp"
                width="21"
                onChange={fileChange}
                handleCancelFileInput={() => handleCancelImage()}
                fileInputView={
                  pathType === "edit" && !(thumbinalViewBtn?.length == "1")
                }
              />
              <div className={classes.infoIcon}>
                <Tooltip
                  direction="right"
                  content="Format Supported: .png, .jpg, .gif, .bmp"
                >
                  <InfoIcon />
                </Tooltip>
              </div>
            </div>
            <div className={classes.topicBtns}>
              {/* {!isDirty && (
                <div
                  className={classes.clearAll}
                  onClick={() =>
                    navigate(`${topicManagement.path(tenantName)}`)
                  }
                >
                  <FormattedMessage id="USERGRP_CANCELBTN_TEXT" />
                </div>
              )} */}
              {isDirty && (
                <div className={classes.clearAll} onClick={clearAll}>
                  <FormattedMessage id="CLEAR_ALL_TXT" />
                </div>
              )}
              <Button
                label="Save & Next"
                type="submit"
                small
                dark
                disabled={
                  !isValid ||
                  exitTopicExist ||
                  !validClassName ||
                  !validTagSearch
                }
              />
            </div>
          </div>
        </form>
      </FormProvider>
    </div>
  );
};

export default injectIntl(NewTopicDetail);
